import moment from "moment";
import { ErrorToast } from "../Admin/Components/ToastComponent/RectHotToast";
const IsoToDateTime = (iso) => {
  const date = new Date(iso);
  const offsetHours = 5;
  const offsetMinutes = 30;

  // Apply the hour and minute offsets
  date.setUTCHours(date.getUTCHours() + offsetHours);
  date.setUTCMinutes(date.getUTCMinutes() + offsetMinutes);

  // Format date components
  const year = date.getUTCFullYear();
  const month = ("0" + (date.getUTCMonth() + 1)).slice(-2); // Months are 0-indexed
  const day = ("0" + date.getUTCDate()).slice(-2);
  let hours = date.getUTCHours();
  const minutes = ("0" + date.getUTCMinutes()).slice(-2);
  const seconds = ("0" + date.getUTCSeconds()).slice(-2);

  // Determine AM/PM and adjust hours to 12-hour format
  let time = "AM";
  if (hours >= 12) {
    time = "PM";
    if (hours > 12) {
      hours -= 12;
    }
  }
  if (hours === 0) {
    hours = 12; // Midnight case
  }

  // Ensure two-digit hour format
  hours = ("0" + hours).slice(-2);

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${time}`;
};

export const IsoToDateTimeAccordingToIndia = (iso) => {
  const date = new Date(iso);

  // Apply the hour and minute offsets
  date.setUTCHours(date.getUTCHours());
  date.setUTCMinutes(date.getUTCMinutes());

  // Format date components
  const year = date.getUTCFullYear();
  const month = ("0" + (date.getUTCMonth() + 1)).slice(-2); // Months are 0-indexed
  const day = ("0" + date.getUTCDate()).slice(-2);
  let hours = date.getUTCHours();
  const minutes = ("0" + date.getUTCMinutes()).slice(-2);
  const seconds = ("0" + date.getUTCSeconds()).slice(-2);

  // Determine AM/PM and adjust hours to 12-hour format
  let time = "AM";
  if (hours >= 12) {
    time = "PM";
    if (hours > 12) {
      hours -= 12;
    }
  }
  if (hours === 0) {
    hours = 12; // Midnight case
  }

  // Ensure two-digit hour format
  hours = ("0" + hours).slice(-2);

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${time}`;
};

// export const IsoToDateWithoutTime = (iso) => {
//   // console.log(iso, "isoiso");
//   if (!iso) return "";

//   const date = new Date(iso);
//   const year = date.getUTCFullYear();
//   const month = ("0" + (date.getUTCMonth() + 1)).slice(-2); // Months are 0-indexed in JavaScript
//   const day = ("0" + date.getUTCDate()).slice(-2);
//   let hours = ("0" + date.getUTCHours()).slice(-2);

//   if (hours > 12) {
//     hours = hours - 12;
//   }
//   // console.log(`${day}/${month}/${year}`, iso);
//   return `${day}/${month}/${year}`;

//   // Should log "09/03/2023" for this example

//   // return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${time}`;
//   // const isodateStr = iso;
//   // const dt = new Date(isodateStr);
//   // const normalStr = dt.toLocaleString();
//   // return normalStr;
// };

export const IsoToDateWithoutTime = (iso) => {

  // // 2025-06-25T05:22:19.447Z global
  // //2025-06-30T18:34:42.232   noramal one 
  // // console.log(iso, "isoiso");
  // if (!iso) return "";

  // const date = new Date(iso);
  // const year = date.getUTCFullYear();
  // const month = ("0" + (date.getUTCMonth() + 1)).slice(-2); // Months are 0-indexed in JavaScript
  // const day = ("0" + date.getUTCDate()).slice(-2);
  // let hours = ("0" + date.getUTCHours()).slice(-2);

  // if (hours > 12) {
  //   hours = hours - 12;
  // }
  // // console.log(`${day}/${month}/${year}`, iso);
  // return `${day}/${month}/${year}`;

   if (!iso) return "";

  // Decide whether we have a trailing 'Z' (UTC) or not
  const isUTC = iso.trim().endsWith("Z");

  const d = new Date(iso);
  let year, month, day;

  if (isUTC) {
    year  = d.getUTCFullYear();
    month = d.getUTCMonth() + 1;     // 0-indexed
    day   = d.getUTCDate();
  } else {
    year  = d.getFullYear();
    month = d.getMonth() + 1;
    day   = d.getDate();
  }

  // pad to two digits
  const mm = String(month).padStart(2, "0");
  const dd = String(day).padStart(2, "0");

  return `${dd}/${mm}/${year}`;

};
export default IsoToDateTime;

const IsoToDateWithTime = (iso) => {
  const date = new Date(iso);
  const year = date.getUTCFullYear();
  const month = ("0" + (date.getUTCMonth() + 1)).slice(-2); // Months are 0-indexed in JavaScript
  const day = ("0" + date.getUTCDate()).slice(-2);
  let hours = ("0" + date.getUTCHours()).slice(-2);
  const minutes = ("0" + date.getUTCMinutes()).slice(-2);
  const seconds = ("0" + date.getUTCSeconds()).slice(-2);
  if (hours > 12) {
    hours = hours - 12;
  } else if (hours === 12) {
  }
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};
export { IsoToDateWithTime };
export const GetOnlyYear = (iso) => {
  const [year, month, day] = iso?.split("T")[0].split("-");
  // console.log(year);
  return year;
};
export const OnlyToShowDate = (iso) => {
  if (!iso) {
    return;
  }
  // console.log(iso?.split("T")[0].split("-"), "iso?.split('T')[0].split('-')iso?.split('T')[0].split('-')");
  const [year, month, day] = iso?.split("T")[0].split("-"); // Extract year, month, day directly from the string
  return `${day}/${month}/${year}`;
};

export const OnlyToShowYear = (iso) => {
  const parts = iso.split("/"); // Split by "/"
  const formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`; // Rearrange to MM/DD/YYYY format
  const date = new Date(formattedDate);

  if (!isNaN(date)) {
    return date.getFullYear().toString(); // Return year as string
  } else {
    return "Invalid date format"; // Handle invalid date format
  }
};

export const convertInDate = (date) => {
  let D = Number(date);
  if (isNaN(D)) {
    // const IsoToDateWithTime = (iso) => {
    //   const date = new Date(iso);
    //   const year = date.getUTCFullYear();
    //   const month = ("0" + (date.getUTCMonth() + 1)).slice(-2); // Months are 0-indexed in JavaScript
    //   const day = ("0" + date.getUTCDate()).slice(-2);
    //   return `${day}/${month}/${year}`;
    // };
  } else {
    // let timestamp = "1699007828390";
    let d = new Date(parseInt(date, 10));
    return IsoToDateTime(d.toISOString());
  }
};

export const toISODateWithIST = (input) => {
  const parts = input.split("/");
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // JS months are zero-indexed
  const year = parseInt(parts[2], 10);
  const now = new Date();

  const date = new Date(year, month, day, now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
  // Adjust for IST (+5:30)
  const ISTOffset = 5.5 * 60 * 60000; // 5.5 hours in milliseconds
  const ISTDate = new Date(date.getTime() + ISTOffset);
  return ISTDate.toISOString();
};

// Usage
// console.log(toISODateWithIST("11/03/2025"));

export function convertToISO(dateString) {
  console.log(dateString, "dateStringdateString");
  const formats = ["DD/MM/YYYY", "YYYY-MM-DD"];
  const m = moment.tz(dateString, formats, true, "Asia/Kolkata");

  if (!m.isValid()) {
    ErrorToast("Please enter a valid date (DD/MM/YYYY or YYYY‑MM‑DD).");
    return;
  }

  // Inject current IST time
  const nowIST = moment.tz("Asia/Kolkata");
  m.set({
    hour: nowIST.hour(),
    minute: nowIST.minute(),
    second: nowIST.second(),
    millisecond: nowIST.millisecond(),
  });

  // Return in "YYYY-MM-DD HH:mm:ss.SSS" format
  return m.format("YYYY-MM-DD[T]HH:mm:ss.SSS");
}

export function convertFromISOWithIST(isoDateString) {
  // Create a Date object from the ISO string
  let date = new Date(isoDateString);

  // Adjust for Indian Standard Time (UTC+5:30)
  date.setHours(date.getHours() - 5);
  date.setMinutes(date.getMinutes() - 30);

  // Extract day, month, and year
  let day = date.getDate();
  let month = date.getMonth() + 1; // Adjust for 0-indexing
  let year = date.getFullYear();

  // Format day and month to ensure two digits
  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;

  // Format into "dd/mm/yyyy"
  return `${day}/${month}/${year}`;
}

export function convertTimeToNormal(timeString) {
  // Extract time and timezone offset
  const [time, zone] = timeString.split(" ");
  const [hours, minutes, seconds] = time.split(":").map(Number);
  const offset = parseInt(zone.substr(3, 2), 10) * 60 + parseInt(zone.substr(5, 2), 10);

  // Create a Date object (assuming the current date)
  const date = new Date();
  date.setHours(hours, minutes - offset, seconds, 0);

  // Format the date into a readable format
  let readableTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Change to false for 24-hour format
  });

  return readableTime;
}
